// removed by extract-text-webpack-plugin
module.exports = {"tablaInventariosFCV":"TablaRegiones__tablaInventariosFCV___1b-Wc","thCorrelativo":"TablaRegiones__thCorrelativo___2CWjo","thNumero":"TablaRegiones__thNumero___w3kMs","thNombre":"TablaRegiones__thNombre___3cldE","thPrecio":"TablaRegiones__thPrecio___3uw9o","thRealizadas":"TablaRegiones__thRealizadas___11h4z","thTotal":"TablaRegiones__thTotal___4eUmY","thOpcion":"TablaRegiones__thOpcion___1w_fA","tdNombre":"TablaRegiones__tdNombre___3sOol","tdRealizadas":"TablaRegiones__tdRealizadas___BYD1k","tdTotal":"TablaRegiones__tdTotal___1oJNA","tdOpcion":"TablaRegiones__tdOpcion___kz5cL"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/auditorias/resumen-mensual/TablaRegiones.css
// module id = 1116
// module chunks = 0